var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseCirclePicture',{staticClass:"base-circle",attrs:{"imageUrl":_vm.imageUrl,"imageSize":_vm.imageSize,"enableHoverAct":_vm.enableHoverAct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }